import styled from 'styled-components'

export const Label = styled.label`
  color: ${props => props.theme.color.onPrimaryDark};
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  opacity: 0.48;
  margin-bottom: 8px;
  white-space: nowrap;
`
